module.exports = __webpack_public_path__ + "static/media/labelWithBackgroundColorButtonDown.af7f51d7.svg";